document.addEventListener("DOMContentLoaded", function () {
   const canvas = document.querySelector("canvas");
    const context = canvas.getContext("2d");

    const frames = {
        currIndex: 0,
        maxIndex: 199
    };

    let imagesLoaded = 0;
    const images = [];

    function preLoadImages() {
        for (let i = 1; i <= frames.maxIndex; i++) {
     
          const imageUrl=`https://cdn.shopify.com/s/files/1/0822/3018/2215/files/Image_${i.toString().padStart(5, "0")}.png`
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
                imagesLoaded++;
                if (imagesLoaded === frames.maxIndex) {
                    loadImage(frames.currIndex);
                    startAnimation();
                }
            };
            images.push(img);
        }
    }

    function loadImage(index) {
        if (index >= 0 && index <= frames.maxIndex) {
            const img = images[index];

            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            const scaleX = canvas.width / img.width;
            const scaleY = canvas.height / img.height;
            const scale = Math.max(scaleX, scaleY);

            const newWidth = img.width * scale;
            const newHeight = img.height * scale;

            const offsetX = (canvas.width - newWidth) / 2;
            const offsetY = (canvas.height - newHeight) / 2;

            context.clearRect(0, 0, canvas.width, canvas.height);
            context.imageSmoothingEnabled = true;
            context.imageSmoothingQuality = "high";
            context.drawImage(img, offsetX, offsetY, newWidth, newHeight);

            frames.currIndex = index;
        }
    }

    function startAnimation() {
        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".scroll-container",
              start :"center bottom ",
              end:"center 10%",
                // start: "top 90%",
                // end: "bottom 30%",
        ease: "slow(0.7,0.7,false)",
        
                scrub: 3,
             duration:2.5,
         
              // markers:true,
            }
        });

        tl.to(frames, {
            currIndex: frames.maxIndex,
            onUpdate: function () {
                loadImage(Math.floor(frames.currIndex));
            }
        });
    }

    preLoadImages();
});